exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.notifications-announcement-circle-announcement{position:absolute;right:-372px;width:372px;height:372px}@media only screen and (min-device-width:320px) and (max-device-width:480px){.notifications-announcement-circle-announcement{right:-260px;bottom:-260px;width:260px;height:260px}.notifications-announcement-circle-announcement .swoop-arrow{position:absolute;left:33px;top:15px;width:183px;opacity:.3;height:212px;background-image:url(" + require("../../../../assets/images/swoop-arrow.svg") + ");background-repeat:no-repeat;background-size:183px 230px}}@media only screen and (min-device-width:481px){.notifications-announcement-circle-announcement{top:-372px}}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/CircleAnnouncement/NotificationsAnnouncementCircleAnnouncement/NotificationsAnnouncementCircleAnnouncement.scss
// module id = 1704
// module chunks = 0